<template>
  <div>
    <button
        class="px-4 py-2 rounded border bg-background-academy
        border-background-academy w-auto font-sans-serif
        hover:bg-white text-white hover:text-background-academy
        font-bold cursor-pointer"
        @click="$emit('click')" :class="isLoading ? 'loader '+buttonClass : buttonClass"
    >
        {{ buttonPlaceholder }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    buttonPlaceholder: String,
    buttonClass: String,
    isLoading: Boolean,
  },
};
</script>
